// Traductions françaises pour le module playerholder3
export const messages = {
    "Player": "Lecteur",
    "Status": "Statut",
    "Instructions Title": "Titre des instructions",
    "Instructions": "Instructions",
    "Offline": "Hors ligne",
    "Initializing": "Initialisation",
    "Online": "En ligne"
}

